module.exports = __webpack_public_path__ + "img/saude_e_bem-estar.e981274c.svg";